module.exports = __webpack_public_path__ + "img/pressure.585dc68d.svg";